import FlagNerdHard from "./FlagNerdHard.js";
import { loadShapes, renderShapeQuestion } from "./ShapeNerd.js";

/**
 * Shape Nerd Hard (Lab) : la silhouette de Shape Nerd, mais sans propositions.
 * Le joueur tape le nom du pays, avec la même tolérance aux fautes de frappe que
 * Flag Nerd Hard, dont il reprend la saisie, les vies et la réponse révélée.
 *
 * Pas de tampon de passeport : reconnaître une forme ne dit rien du drapeau ni
 * de la capitale.
 */
export default class ShapeNerdHard extends FlagNerdHard {
	constructor() {
		super("shapenerdhard", ".shape-nerd-hard", {
			labMode: "shapenerdhard",
			gameNameKey: "lab.shapeNerd",
			modeLabelKey: "home.hard",
			mode: "hard",
			shareEmoji: "🟪",
			slug: "shape-nerd-hard",
		});
	}

	// Appelé par `init()`, lui-même lancé par le constructeur parent : les tracés
	// se lisent ici, au premier besoin.
	initCountries() {
		this.shapes ??= loadShapes(this.page);
		super.initCountries(this.shapes.pool);
	}

	getQuestionFlagCodes() {
		return [];
	}

	renderQuestion(country) {
		return renderShapeQuestion(country, this.shapes);
	}
}
